import { render } from "./VettedBusinesses.vue?vue&type=template&id=9483729c"
import script from "./VettedBusinesses.vue?vue&type=script&lang=js"
export * from "./VettedBusinesses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__